<template>
  <v-flex xs12 sm10 md8 lg10>
    <v-card>
      <v-card-actions>
        <v-btn @click="closeCamera">close</v-btn>
        <v-spacer></v-spacer>

        <v-btn fab color="primary" @click="$refs.inputCamera.click()">
          <v-icon>photo_camera</v-icon>
        </v-btn>
        <input
          v-show="false"
          ref="inputCamera"
          type="file"
          accept="image/*"
          capture="camera"
          @change="uploadFile()"
        >

        <v-spacer></v-spacer>
      </v-card-actions>
      <v-container grid-list-sm fluid>
        <v-layout row wrap>
          <v-flex v-for="(url, index) in photos" v-bind:key="index" xs12 md5 lg4>
            <v-img :src="url">
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="amber"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-flex>
</template>
<style>
.input-file {
  width: 200px;
  height: 200px;
  display: none;
  cursor: pointer;
}
div.camera {
  cursor: pointer;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "camera",
  computed: {
    ...mapGetters({
      active: "activeAddress",
      photos: "photoUrls"
    })
  },
  methods: {
    ...mapActions(["closeCamera", "savePhoto"]),
    uploadFile() {
      var file = this.$refs.inputCamera.files[0];
      var formData = new FormData();
      formData.append("file", file);
      formData.append("uniqueIdAssignment", this.active.uniqueIdAssignment);
      formData.append("uniqueIdAddress", this.active.uniqueIdAddress);
      this.savePhoto(formData);
    }
  }
};
</script>
